module.exports = __webpack_public_path__ + "static/media/backgroud1.ed1a7afa.jpg";